// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global overflow prevention */
html, body {
  overflow-x: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}

.App {
  text-align: left;
  min-height: 100vh;
  overflow-x: hidden;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Simulation Status Dot Badge Animation */
@keyframes simDotPulse {
  0%, 100% { transform: scale(1);   opacity: 1; }
  50%       { transform: scale(1.45); opacity: 0.65; }
}

html[data-automation-mode="true"] *,
html[data-automation-mode="true"] *::before,
html[data-automation-mode="true"] *::after {
  animation-duration: 0.001ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.001ms !important;
  scroll-behavior: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0CAA0C;AAC1C;EACE,WAAW,mBAAmB,IAAI,UAAU,EAAE;EAC9C,YAAY,sBAAsB,EAAE,aAAa,EAAE;AACrD;;AAEA;;;EAGE,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;AAClC","sourcesContent":["/* Global overflow prevention */\nhtml, body {\n  overflow-x: hidden;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  text-align: left;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Simulation Status Dot Badge Animation */\n@keyframes simDotPulse {\n  0%, 100% { transform: scale(1);   opacity: 1; }\n  50%       { transform: scale(1.45); opacity: 0.65; }\n}\n\nhtml[data-automation-mode=\"true\"] *,\nhtml[data-automation-mode=\"true\"] *::before,\nhtml[data-automation-mode=\"true\"] *::after {\n  animation-duration: 0.001ms !important;\n  animation-iteration-count: 1 !important;\n  transition-duration: 0.001ms !important;\n  scroll-behavior: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
